import React, { ReactElement } from 'react'
import { TbTableRowData } from 'tinybots-react-components'
import { VoiceAssistantRow } from '../types/VoiceAssistantRow'
import moment from 'moment'
import { PrintButton } from '../VoiceAssistantEnrollment/PrintButton'
import { useDymo } from '../../../common/hooks/useDymo'

export const useVoiceAssistantEnrollmentValueMapper = () => {
  const { dymoConnected, tbDymo } = useDymo()

  return ({ row, valueKey }: { row: TbTableRowData, valueKey: string }) => {
    const { serial, boxNumber, hardwareVersion } = row as VoiceAssistantRow

    const inputValue = row[valueKey as keyof VoiceAssistantRow]
    const stringOrNumber = typeof inputValue === 'string' || typeof inputValue === 'number'
    let value: ReactElement | string | number
    let tooltipValue: ReactElement | string | number
    const tooltip = false
    const color = 'black'
    const style = {
      color: value === 'N/A' ? 'rgb(163 163 163)' : color,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      lineHeight: '36px',
      fontFamily: value === 'N/A' ? 'Roboto-Mono-Light' : 'inherit'
    }
    switch (valueKey) {
      case 'createdAt':
        value = inputValue ? moment(inputValue as string).format('hh:mm DD-MM-YYYY') : '-'
        break
      case 'buttons':
        value = (
                    <section>
                        <PrintButton
                            tbDymo={tbDymo}
                            boxNumber={boxNumber}
                            hardwareVersion={hardwareVersion}
                            serial={serial}
                            dymoConnected={dymoConnected}
                        ></PrintButton>
                    </section>
        )
        break
      default:
        value = stringOrNumber ? inputValue ?? '-' : '-'
        break
    }
    value = <span style={style}>{value}</span>
    return { value, tooltip, tooltipValue }
  }
}
